import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Popover } from 'antd';
import colors from '~/constants/colors';
import { useDirection } from '~/hooks/i18nHooks';
import { ContactUsIcon } from '~/img';
import direction from '~/utils/direction';

interface Props {
  url: string;
  textPosition?: 'left' | 'right';
}

const ContactUs: FC<Props> = (props) => {
  const { url, textPosition } = props;
  const { t } = useTranslation();
  const dir = useDirection();

  return (
    <Popover
      content={
        <div style={{ width: 270 }}>
          <p>If you have any queries, please write to commercial card business team at ‘Commercial@network.global‘</p>
        </div>
      }
    >
      <Div id="contactUsButton" className="ContactUs" dir={dir}>
        {textPosition === 'left' && <span className="ContactUs-Text-Left">{t('Contact us')}</span>}
        <ContactUsIcon className="ContactUs-Icon" dir={dir} />
        {(textPosition === 'right' || !textPosition) && <span className="ContactUs-Text-Right">{t('Contact us')}</span>}
      </Div>
    </Popover>
  );
};

const Div = styled.a`
  display: flex;
  margin-top: auto;
  color: ${colors.textColor};
  &:hover {
    color: ${colors.primaryContactUsButtonHoverColor};
  }
  &:focus {
    color: ${colors.primaryContactUsButtonHoverColor};
  }
  .ContactUs-Icon {
    font-size: 40px;
    color: ${colors.primaryContactUsButtonColor};
  }
  .ContactUs-Text-Right {
    display: flex;
    ${direction.margin.left(8)}
    text-transform: uppercase;
    line-height: 40px;
    font-size: 14px;
  }
  .ContactUs-Text-Left {
    display: flex;
    ${direction.margin.right(8)}
    text-transform: uppercase;
    line-height: 40px;
    font-size: 14px;
  }
`;

export default ContactUs;
